module.exports = __webpack_public_path__ + "static/media/pc_icon_code_finish.2ab058e0.svg";